import { Env } from './env.model';

export const environment: Env = {
  envName: 'dev',
  apiBaseUrl: 'https://gw.dev.my.jobfixers.be/v1/myjobfixers/api/v1',
  publicApiBaseUrl: 'https://gw.dev.my.jobfixers.be/v1/myjobfixers/publicapi',
  mediaUrl: 'https://gw.dev.my.jobfixers.be/v1/media/api/open/media',
  privateMediaUrl: 'https://gw.dev.my.jobfixers.be/v1/media/api/private/media',
  googleMapsApiKey: 'AIzaSyBYAs7O218okq_UrkNDv68ppIdaSRRwbWc',
  sentryDsn: '',

  get titlePrefix(): string {
    return `${this.envName.toUpperCase()} MyJobFixers | `;
  },
};
